import { createSlice } from '@reduxjs/toolkit';

const groupSlice = createSlice({
  name: 'group',
  initialState: {
    groups: [],
    dataValid: false,
    selectedGroup: {}
  },
  reducers: {
    setGroups(state, action) {
        console.count("groupSlice: setGroups");
        if (!action || !action.payload || !action.payload.groups) {
          state.groups = [];
        } else {
          state.groups = action.payload.groups;
        }      
    },
    setGroup(state, action) {
      if (!action || !action.payload || !!action.payload.group) return;
      state.groups = state.groups
          .filter((item) => item.id !== action.payload.group.id)
          .push(action.payload.group);
    },
    removeGroup(state, action) {
      if (!action || !action.payload || !!action.payload.group) return;
      state.groups = state.groups.filter((item) => item.id !== action.payload.group.id);
    },
    invalidateData(state, action) {
      state.dataValid = false;
    },
    setSelectedGroup(state, action) {
      if (!action || !action.payload || !!action.payload.selectedGroup) return;
      state.selectedGroup = action.payload.selectedGroup
    }
  },
});

export const groupActions = groupSlice.actions;

export default groupSlice;